import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { crefazService } from '../services/crefazService'
import { useToast } from '@/view/components/ui/use-toast'

export const useOccupations = () => {
  const { isError, isFetching, isLoading, data } = useQuery({
    queryKey: ['occupations'],
    queryFn: crefazService.getOccupations,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar ocupações, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
  }
}
